import React from 'react';

const CreateVendor = () => {
    return <div>CreateVendor</div>;
};

export default CreateVendor;
